/**
 * Product card functionality.
 * Mostly related to size selection.
 * Product cards are created and destroyed dynamically so we need delegated events.
 *
 * Minimum markup needed:

  <div data-product-card>
    <select data-product-card-size-select>
      <option value="size-1" selected>Size 1</option>
      <option value="size-2">Size 2</option>
    </select>

    <div data-product-card-size="size-1">...</div>
    <div data-product-card-size="size-2" class="hidden">...</div>
  </div>
 */
class ProductCard {

  constructor() {
    document.addEventListener('change', (event: Event) => {
      const target = event.target as HTMLElement;

      if(target && target.matches('select[data-product-card-size-select]')) {
        this.onSizeSelectChange(event);
      }
    });
  }

  onSizeSelectChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const value = select.value;

    if(value) {
      const productCardElement = select.closest('[data-product-card]') as HTMLElement;
      if(!productCardElement) {
        console.warn('[ProductCard] Could not find product card element for size select', select);
        return;
      }

      const sizeElements: NodeListOf<HTMLElement> = productCardElement.querySelectorAll('[data-product-card-size]');

      sizeElements.forEach(el => {
        if(el.dataset.productCardSize === value) {
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      });
    }
  }
}

export function init(): void {
  console.log('product-card.init()');
  new ProductCard();
}

export default ProductCard;
